import { Service } from 'vue-di-container';
import moment from 'moment-hijri';

@Service()
export default class ValidationService {
  public readonly phoneCodePhoneNumber: string = '05';
  public readonly phoneCodeFixedPhone: string = '01';
  public readonly emailPattern: RegExp = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/;

  public isValidEmail(email: string) {
    return this.emailPattern.test(email);
  }
  public validateLength(max: number, text: any, evt?: KeyboardEvent): boolean {
    if (evt !== undefined) {
      const pattern = /^[0-9]+$/;
      if ((text && text.length >= max) || !pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return text && text.length <= max ? true : false;
    }
  }
  public isValidNumber(
    phoneNumber: string,
    prefixNumber: string,
    length: number
  ): boolean {
    return (
      phoneNumber.length === length && phoneNumber.startsWith(prefixNumber)
    );
  }
  public isArabic(text: string) {
    const pattern = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
    return pattern.test(text);
  }
  public calculateRemainingCharactersCount(count: number, value: string) {
    return count - value.length;
  }
  public maxLength(max: number, that: any, evt: Event) {
    if (that.length >= max) {
      evt.preventDefault();
      return false;
    }
  }

  public validateNumeric(max: number, text: any, evt?: KeyboardEvent): boolean {
    if (evt !== undefined) {
      const pattern = /^[0-9]+$/;
      if ((text && text.length >= max) || !pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return text && text.length <= max ? true : false;
    }
  }
  public validateArabic(text: any, evt?: KeyboardEvent): boolean {
    if (evt !== undefined) {
      const pattern = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  public validateArabicMaxLength(
    text: any,
    max: number,
    evt?: KeyboardEvent
  ): boolean {

    if (evt !== undefined) {
      let txtTst = '';
      if (text !== undefined) {
        txtTst = text;
      }
      if (txtTst.length >= max) {
        evt.preventDefault();
        return false;
      }
      const pattern = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  public validateEnglishMaxLength(
    text: any,
    max: number,
    evt?: KeyboardEvent
  ): boolean {
    if (evt !== undefined) {
      let txtTst = '';
      if (text !== undefined) {
        txtTst = text;
      }

      if (txtTst.length >= max) {
        evt.preventDefault();
        return false;
      }
      const pattern = /^[a-z\d]*[a-z\d]*$/i;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  private stringStartWith(test: string, chars: string[]): boolean {
    return chars.some(ch => test.startsWith(ch));
  }

  public validateEnglishMaxLengthStartWith(
    text: any,
    max: number,
    startWith: string[],
    doesnotStartWith: string[],
    evt?: KeyboardEvent
  ): boolean {
   
    if (evt !== undefined) {
      let txtTst = '';
      if (text !== undefined) {
        txtTst = text;
      }

      if (txtTst.length >= max) {
        evt.preventDefault();
        return false;
      }

      if (startWith.length > 0) {
        if (txtTst.length == 0 && !(this.stringStartWith(evt.key, startWith))) {
          evt.preventDefault();
          return false;
        }
      }

      if (doesnotStartWith.length > 0) {
        if (txtTst.length == 0 && this.stringStartWith(evt.key, doesnotStartWith)) {
          evt.preventDefault();
          return false;
        }
      }


      const pattern = /^[a-z\d]*[a-z\d]*$/i;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  public validateEnglishEmailMaxLength(
    text: any,
    max: number,
    evt?: KeyboardEvent
  ): boolean {
   
    if (evt !== undefined) {
      let txtTst = '';
      if (text !== undefined) {
        txtTst = text;
      }

      if (txtTst.length >= max) {
        evt.preventDefault();
        return false;
      }
      const pattern = /^[a-z\d\.\@]*[a-z\d\.\@]*$/i;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  public isNumeric(text: any): boolean {
    const pattern = /^[0-9]+$/;
    return pattern.test(text);
  }

  public identityPaste(evt: any) {
    var value = evt.clipboardData.getData('text');
    if (this.isArabic(value) || value.length > 15) {
      evt.preventDefault();
    }
  }

  public identifaicationNumberOnKeyPress(evt: any) {
    const regex = /^[a-zA-Z0-9]*$/;
    if (!evt.key.match(regex) || evt.target.value.length >= 15) {
      evt.preventDefault();
    }
  }

  public onPasteWekala(evt: any) {
    var value = evt.clipboardData.getData('text');
    if (this.isArabic(value) || !this.isNumeric(value)) {
      evt.preventDefault();
    }
  }

  public procurationNumberOnKeyPress(evt: any) {
    const regex = /^[0-9]*$/;
    if (!evt.key.match(regex) || evt.target.value.length >= 11) {
      evt.preventDefault();
    }
  }

  public getDateFormate(date: string): string {
    let formate: string = '';

    if (moment(date, 'iDD/iMM/iYYYY', true).isValid()) {
      formate = 'iDD/iMM/iYYYY';
      return formate;
    }

    if (moment(date, 'iYYYY/iMM/iDD', true).isValid()) {
      formate = 'iYYYY/iMM/iDD';
      return formate;
    }

    if (moment(date, 'iDD-iMM-iYYYY', true).isValid()) {
      formate = 'iDD-iMM-iYYYY';
      return formate;
    }

    if (moment(date, 'iYYYY-iMM-iDD', true).isValid()) {
      formate = 'iYYYY-iMM-iDD';
      return formate;
    }

    if (moment(date, 'DD/MM/YYYY', true).isValid()) {
      formate = 'DD/MM/YYYY';
      return formate;
    }
    if (moment(date, 'YYYY/MM/DD', true).isValid()) {
      formate = 'YYYY/MM/DD';
      return formate;
    }

    if (moment(date, 'DD-MM-YYYY', true).isValid()) {
      formate = 'DD-MM-YYYY';
      return formate;
    }

    if (moment(date, 'YYYY-MM-DD', true).isValid()) {
      formate = 'YYYY-MM-DD';
      return formate;
    }

    return formate;
  }
}
